<script lang="ts">
  import { goto } from '$app/navigation';
  import type { ClassSummary } from '$lib/api/types';
  import { auth } from '$lib/stores/auth.svelte';
  import { formatDate } from '$lib/util';

  interface Props {
    classes: ClassSummary[];
  }

  let { classes }: Props = $props();
  function classLink(id: number) {
    if (auth.isAdmin) {
      return `/admin/classes/${id}`;
    }

    return `/instructors/classes/${id}`;
  }
</script>

<table class="table table-borderless table-hover mt-3">
  <thead>
    <tr class="border-bottom">
      <th scope="col">Class Name</th>
      <th scope="col" class="mdvp-hidden">Start Date</th>
      <th scope="col" class="mdvp-hidden">End Date</th>
      {#if auth.isAdmin}
        <th scope="col" class="text-end mdvp-hidden">Clinical Groups</th>
        <th scope="col" class="text-end mdvp-hidden">Students</th>
      {/if}
    </tr>
  </thead>
  <tbody>
    {#each classes as clazz (clazz.id)}
      <tr onclick={() => goto(classLink(clazz.id))}>
        <td><a href={classLink(clazz.id)}>{clazz.name}</a></td>
        <td class="mdvp-hidden">{formatDate(clazz.startDate)}</td>
        <td class="mdvp-hidden">{formatDate(clazz.endDate)}</td>
        {#if auth.isAdmin}
          <td class="text-end mdvp-hidden">{clazz.clinicalGroupCount}</td>
          <td class="text-end mdvp-hidden">{clazz.studentCount}</td>
        {/if}
      </tr>
    {/each}
  </tbody>
</table>

<style>
  .table > tbody > tr > * {
    cursor: pointer;
  }
</style>
